module.exports = __webpack_public_path__ + "static/company-9f4edaccbb0bfeb91741b13595e3450c.jpg";